import CloseWhiteboardDialog from 'features/whiteboard/modals/CloseWhiteboardDialog';

const CloseRestorableWhiteboardModal = () => (
  <CloseWhiteboardDialog
    modalName="closeRestorableWhiteboard"
    translationKey="close_restorable_whiteboard"
    offerDontShowAgain
  />
);

export default CloseRestorableWhiteboardModal;
